import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '@fullcalendar/timeline/main.css';
import '@fullcalendar/resource-timeline/main.css';

import "../../stylesheets/fullcalendar.scss";

import Fullcalendar from '../lib/fullcalendar.js';

STUDIP.Fullcalendar = Fullcalendar;
